import { useState, useEffect } from "react";
import { motion } from "framer-motion";

/*
  Shared language-greetings pack — used by:
   - Desi TV page hero (rotating)
   - Homepage hero modal (rotating)
   - Ask Nema recommender (region-aware, static pill)
*/

export const GREETINGS = [
  { script: "नमस्ते",       roman: "Namaste",  lang: "hi", regions: ["india", "nepal", "hindi", "nepali", "indian"] },
  { script: "স্বাগতম",       roman: "Shagotom", lang: "bn", regions: ["bangladesh", "bangla", "bengali"] },
  { script: "السلام علیکم", roman: "Salaam",   lang: "ur", rtl: true, regions: ["pakistan", "urdu"] },
  { script: "أهلاً",         roman: "Ahlan",    lang: "ar", rtl: true, regions: ["arab", "arabic", "saudi", "uae", "emirates", "egypt", "lebanon", "morocco", "syria"] },
];

// Return the greeting whose region list matches (case-insensitive substring), or null.
export const matchGreeting = (text) => {
  if (!text) return null;
  const t = text.toLowerCase();
  return GREETINGS.find((g) => g.regions.some((r) => t.includes(r))) || null;
};

// Reusable rotating greeting block for hero surfaces.
export const RotatingGreeting = ({ testId = "rotating-greeting", small = false }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % GREETINGS.length), 3200);
    return () => clearInterval(t);
  }, []);
  const g = GREETINGS[i];
  const scriptClass = small
    ? "font-display font-extrabold text-xl md:text-2xl leading-none"
    : "font-display font-extrabold text-3xl md:text-4xl leading-none";
  const textClass = small ? "text-xs md:text-sm" : "text-sm md:text-base";
  return (
    <div
      data-testid={testId}
      className={`flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1 ${
        small ? "min-h-[2rem]" : "min-h-[2.75rem] md:min-h-[3rem]"
      }`}
    >
      <motion.span
        key={g.script}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        lang={g.lang}
        dir={g.rtl ? "rtl" : "ltr"}
        data-testid={`greeting-${g.lang}`}
        className={scriptClass}
        style={{
          backgroundImage: "linear-gradient(90deg, #FFB800 0%, #FF7A1A 60%, #F43F5E 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        {g.script}
      </motion.span>
      <span className={`${textClass} text-white/70 tracking-wide`}>
        <span className="text-white/90 font-semibold">{g.roman}</span>
        {" — welcome home, wherever home is."}
      </span>
    </div>
  );
};
